export const SUPPORTED_UPLOAD_ACCEPT =
  '.pdf,.docx,.xlsx,.xlsm,.tif,.tiff,.txt,.csv,.eml,.msg,.png,.jpg,.jpeg,.webp,.mp4';

export const SUPPORTED_UPLOAD_TYPES_LABEL =
  'Supports PDF, DOCX, XLSX, TIFF, TXT, CSV, PNG, JPG, WEBP, EML, MSG, MP4';

const SUPPORTED_UPLOAD_EXTENSIONS: ReadonlySet<string> = new Set(
  SUPPORTED_UPLOAD_ACCEPT.split(',').map((ext) => ext.trim().toLowerCase()),
);

/**
 * Whether a file has a supported extension. The `accept` attribute on a file input is
 * only a hint for the browse dialog and is ignored for drag and drop, so files must be
 * validated explicitly.
 */
export const isSupportedUploadFile = (file: File): boolean => {
  const dot = file.name.lastIndexOf('.');
  if (dot < 0) return false;
  return SUPPORTED_UPLOAD_EXTENSIONS.has(file.name.slice(dot).toLowerCase());
};

export const formatRejectedFilesMessage = (rejected: File[]): string => {
  const names = rejected.map((f) => `"${f.name}"`).join(', ');
  const noun = rejected.length === 1 ? 'file was' : 'files were';
  return `${rejected.length} ${noun} not uploaded because the file type is not supported: ${names}.`;
};
